import auth from "./auth";
import entities from "./entities";
import system from "./system";
import entity from "../../modules/entity/actions";

export default {
	auth,
	entities,
	system,
	entity
};
